let fallbackCounter = 0;

/** A conversation id. Browsers provide crypto.randomUUID; the fallback is for test runtimes without it. */
export const newConversationId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  fallbackCounter += 1;
  return `${Date.now().toString(36)}-${fallbackCounter.toString(36)}`;
};

export const seconds = (from: string | null, to: string | null): string | null => {
  if (!from || !to) {
    return null;
  }
  return `${Math.max(1, Math.round((new Date(to).getTime() - new Date(from).getTime()) / 1000))}s`;
};

export const relative = (iso: string): string => {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes}m ago`;
  }
  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `${hours}h ago`;
  }
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};
